import { ApiClientService, AuthService } from '@dfl/react-security';
import {
  BackupCodesResponse,
  GoogleNonceResponse,
  LoginResponse,
  MfaSetupResponse,
  MfaStatusResponse,
} from './mfa.types';

const BASE = process.env.REACT_APP_AUTH_URL || '/ms-auth/api/auth';

class MfaService {
  getStatus = (): Promise<MfaStatusResponse> => AuthService.handleResponse(ApiClientService.get(`${BASE}/mfa`));

  adminLogin = (credentials: unknown): Promise<LoginResponse> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/admin/login`, credentials));

  getAdminGoogleNonce = (): Promise<GoogleNonceResponse> =>
    AuthService.handleResponse(ApiClientService.get(`${BASE}/admin/google/nonce`));

  adminGoogleLogin = (idToken: string, nonce: string): Promise<LoginResponse> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/admin/google`, { idToken, nonce }));

  stepUp = (mfaSession: string, code: string, useBackupCode?: boolean): Promise<LoginResponse> =>
    AuthService.handleResponse(
      ApiClientService.post(`${BASE}/mfa/step-up`, useBackupCode ? { mfaSession, code, useBackupCode } : { mfaSession, code }),
    );

  sendChallenge = (mfaSession: string): Promise<{ sent: true }> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/mfa/challenge`, { mfaSession }));

  startTotpSetup = (): Promise<MfaSetupResponse> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/mfa/totp/setup`, undefined));

  verifyTotpSetup = (code: string): Promise<BackupCodesResponse> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/mfa/totp/setup/verify`, { code }));

  sendEmailSetup = (): Promise<{ sent: true }> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/mfa/email/setup`, undefined));

  verifyEmailSetup = (code: string): Promise<BackupCodesResponse> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/mfa/email/setup/verify`, { code }));

  regenerateBackupCodes = (): Promise<BackupCodesResponse> =>
    AuthService.handleResponse(ApiClientService.post(`${BASE}/mfa/backup-codes/regenerate`, undefined));

  disable = (): Promise<{ enabled: false }> => AuthService.handleResponse(ApiClientService.delete(`${BASE}/mfa`));
}

export default new MfaService();
